import PropTypes from 'prop-types';
import React from 'react';

import UserAdminAddEditUserInfo from '../../UserAdminAddEditUserInfo';

const EditUserInfoPanel = ({ userDetails, setUserDetails }) => {
  return <UserAdminAddEditUserInfo userDetails={userDetails} setUserDetails={setUserDetails} />;
};

EditUserInfoPanel.propTypes = {
  userDetails: PropTypes.object,
  setUserDetails: PropTypes.func,
};

export default EditUserInfoPanel;
